import * as React from 'react';
import { AuthMotivation, CianChatError } from '@cian/newbuilding-chat-component/';
import { TButtonSize } from '@cian/ui-kit/button/types';
import { IconCommunicationConsultant16 } from '@cian/ui-kit-design-tokens/icons';
import { useDispatch, useSelector } from 'react-redux';

import { ChatOnboardingContainer } from '../ChatOnboardingContainer';
import { onEntryAutorisationPopupClick } from './analytics/analytics';
import { useConsultantCianChat } from './hooks/useConsultantCianChat';
import { SendMessageButtonContainer } from './SendMessageButton';
import { getPlaceType } from './utils';
import {
  closeAutorisationMotivationPopup as closeAutorisationMotivationConsultantCianChat,
  closeErrorMessage,
} from '../../slices/consultantCianChat';
import { getGaLabel } from '../../selectors/analytics';
import { getRegionId } from '../../selectors/newbuilding';
import { getBuilderChatEnabled } from '../../selectors/builderChat';
import { isAutorisationPopupOpenSelector, isErrorPopupOpenedSelector } from '../../selectors/consultantChat';
import { selectNewbuildingKpnChatEnabled } from '../../selectors/consultantChat/selectNewbuildingKpnChatEnabled';
import { useApplicationContext } from '../../utils/applicationContext/applicationContext';

interface IConsultantChatButtonProps {
  isHeaderButton?: boolean;
  buttonSize?: TButtonSize;
}

export const ConsultantChatButtonContainer: React.FC<IConsultantChatButtonProps> = ({
  isHeaderButton = false,
  buttonSize = 'M',
}) => {
  const dispatch = useDispatch();
  const context = useApplicationContext();
  const { config } = context;
  const regionId = useSelector(getRegionId);
  const customLabel = useSelector(getGaLabel);
  const isKpnChatsEnabled = useSelector(selectNewbuildingKpnChatEnabled);
  const isKpnChatsFlagEnabled = config.get<boolean>('newbuilding-card-desktop-frontend.KpnChat.Enabled');
  const isAutorisationPopupOpen = useSelector(isAutorisationPopupOpenSelector);
  const isErrorPopupOpened = useSelector(isErrorPopupOpenedSelector);
  const isBuilderChatEnabled = useSelector(getBuilderChatEnabled);
  const { handleOpenChat } = useConsultantCianChat();
  const placeType = getPlaceType(isHeaderButton);

  /* istanbul ignore next */
  const onLogInClick = React.useCallback(() => {
    onEntryAutorisationPopupClick({ regionId, customPageURL: customLabel });
    handleOpenChat();
  }, [customLabel, handleOpenChat, regionId]);

  /* istanbul ignore next */
  const onLogInClose = React.useCallback(() => {
    dispatch(closeAutorisationMotivationConsultantCianChat());
  }, [dispatch]);

  /* istanbul ignore next */
  const onErrorClose = React.useCallback(() => {
    dispatch(closeErrorMessage());
  }, [dispatch]);

  if (!isKpnChatsEnabled || !isKpnChatsFlagEnabled || isBuilderChatEnabled || isHeaderButton) {
    return null;
  }

  return (
    <>
      <ChatOnboardingContainer type="consultant" theme="blue">
        <SendMessageButtonContainer
          size={buttonSize}
          theme={'fill_secondary'}
          ariaLabel="Написать консультанту"
          beforeIcon={<IconCommunicationConsultant16 color="icon-main-default" />}
          noMarginTop
          placeType={placeType}
        />
      </ChatOnboardingContainer>
      <AuthMotivation
        isAutorisationPopupOpened={isAutorisationPopupOpen}
        onClick={onLogInClick}
        onClose={onLogInClose}
      />
      <CianChatError onClose={onErrorClose} open={isErrorPopupOpened} />
    </>
  );
};
